import { render } from "./Main2.vue?vue&type=template&id=8f15c428"
import script from "./Main2.vue?vue&type=script&lang=js"
export * from "./Main2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__